/**
 * 系统自定义配置
 */

const customization = {
    crmUrl:"https://sfademo.recloud.com.cn:9900",
    copyright:"Copyright2005-2023 360.net All Rights Reserved 360数字安全集团 三六零数字安全科技集团有限公司",
    themeColor:""
};

export const copyright = customization.copyright;
export const themeColor = customization.themeColor;
export const crmUrl = customization.crmUrl;

export default customization;



// WEBPACK FOOTER //
// ./src/config/customization.js